"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.removeTrailingSlash = exports.removeQueryStringParam = exports.getValueFromQueryString = exports.getQueryStringParams = exports.buildUrlFromConfig = void 0;var _const = require("../const");


const removeTrailingSlash = (url) => {
  if (!url) return url;
  if (url.endsWith("/")) {
    url = url.substring(0, url.length - 1);
  }
  return url;
};exports.removeTrailingSlash = removeTrailingSlash;

const getValueFromQueryString = (name) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
};exports.getValueFromQueryString = getValueFromQueryString;

const getQueryStringParams = () => {
  return Object.fromEntries(new URLSearchParams(window.location.search).entries());
};

/**
 * Removes a parameter from the query string of a url
 * @param {string} url
 * @param {string} parameter
 * @returns
 */exports.getQueryStringParams = getQueryStringParams;
const removeQueryStringParam = (url, parameter) => {
  const urlParts = url.split('?');
  if (urlParts.length >= 2) {
    const params = new URLSearchParams(urlParts[1]);
    params.delete(parameter);

    //If we have no params, return just the url
    const qs = params.toString();
    if (qs.length === 0) {
      return urlParts[0];
    }

    return `${urlParts[0]}?${qs}`;
  }
  return url;
};exports.removeQueryStringParam = removeQueryStringParam;

const buildUrlFromConfig = (config, additionalPath, additionalParams) => {var _additionalPath;
  const unifiedLoginUrl = removeTrailingSlash(config.unifiedLoginUrl);
  additionalPath = additionalPath || "";
  if (((_additionalPath = additionalPath) === null || _additionalPath === void 0 ? void 0 : _additionalPath.length) > 0 && !additionalPath.startsWith("/")) {
    additionalPath = `/${additionalPath}`;
  }

  const o = {
    ...(_const.QS_CLIENT_TYPE ? { [_const.QS_CLIENT_TYPE]: config.clientType } : {}),
    ...(_const.QS_REDIRECT_URI ? { [_const.QS_REDIRECT_URI]: config.redirectUri } : {}),
    ...additionalParams
  };
  const params = new URLSearchParams(o);
  return `${unifiedLoginUrl}${additionalPath}?${params.toString()}`;
};exports.buildUrlFromConfig = buildUrlFromConfig;